import React, { useState, useEffect } from "react";
import "./Archive.css"
import toast from "react-hot-toast";

const Archive = () => {
  const [archives, setArchives] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [showMore , setShowMore] = useState(false)
  const [archiveType, setArchiveType] = useState("video"); // Default type
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    videoFile: null,
    imageFile: null,
    audioFile: null,
  });

  const [activeTab, setActiveTab] = useState("video");
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

//switch tabs to active
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Fetch all archives
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://admin.riymay.com/api/v1/admin/get/archieves");
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
      
        setData(result.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);


  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
  
    const form = new FormData();
    form.append("archiveType", archiveType);
    form.append("title", formData.title);
    form.append("description", formData.description);
  
    if (archiveType === "video" && formData.videoFile) {
      form.append("files", formData.videoFile);
    } else if (archiveType === "audio") {
      if (formData.imageFile) form.append("files", formData.imageFile);
      if (formData.audioFile) form.append("files", formData.audioFile);
    }
  
    try {
      const response = await fetch("https://admin.riymay.com/api/v1/admin/create/archieve", {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${localStorage.getItem("admintoken")}`,
        },
        body: form,
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const result = await response.json();
      toast.success(result.message);
  
      // ✅ Update UI state immediately
      setArchives((prevArchives) => [...prevArchives, result.data]);
  
      // ✅ Optionally, fetch latest data from backend
      // fetchArchives();
  
      setShowDialog(false);
    
    } catch (error) {
      console.error("Error creating archive:", error);
      toast.error("Failed to upload archive. Please try again.");
    }
  };
  
  // ✅ Function to fetch latest archives (call this after successful upload)
  const fetchArchives = async () => {
    try {
      const response = await fetch("https://admin.riymay.com/api/v1/admin/get/archives", {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem("admintoken")}`,
        },
      });
  
      if (!response.ok) {
        throw new Error("Failed to fetch archives");
      }
  
      const data = await response.json();
      // setArchives(data.videoArchives);
      setArchives((prevArchives) => [...prevArchives, data.data]);

     
    } catch (error) {
      console.error("Error fetching archives:", error);
    }
  };
  
  //delete form submission
  const handleDelete = async (type, id) => {
    // const confirmDelete = window.confirm("Are you sure you want to delete this item?");
    // if (!confirmDelete) return;

    try {
      const response = await fetch(
        `https://admin.riymay.com/api/v1/admin/delete/archieve?type=${type}&id=${id}`,
        { 
          method: "DELETE",
          headers: {
          'Content-Type': 'application/json', // Specify the content type
          'Authorization': `Bearer ${localStorage.getItem("admintoken")}`, // Add the Bearer token
        },
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to delete ${type} with ID ${id}`);
      }

      // Update UI after successful delete
      if (type === "audio") {
        setData((prevData) => ({
          ...prevData,
          imageAudioArchives: prevData.imageAudioArchives.filter((item) => item._id !== id),
        }));
      } else if (type === "video") {
        setData((prevData) => ({
          ...prevData,
          videoArchives: prevData.videoArchives.filter((item) => item._id !== id),
        }));
      }
    } catch (err) {
      alert(`Error: ${err.message}`);
    }
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData({ ...formData, [name]: files[0] });
  };

  return (
    <div className="archive-manager">
      <div className="archive-header-manager">
      <div className="archive-manager__heading orders-header">
          <h3>Archive Manager</h3>
        </div>
        <div><button
        onClick={() => setShowDialog(true)}
        className="archive-manager__open-dialog-btn"
      >
        Create Archive
      </button>
</div>
</div>
      
      {showDialog && (
        <div className="archive-manager__dialog-overlay">
          <div className="archive-manager__dialog-box">
            <form onSubmit={handleSubmit} className="archive-manager__form">
              <h2 className="archive-manager__form-heading">Create Archive</h2>

              <label className="archive-manager__form-label">
                Title:
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                  required
                  className="archive-manager__form-input"
                />
              </label>

              <label className="archive-manager__form-label">
                Description:
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  required
                  className="archive-manager__form-textarea"
                ></textarea>
              </label>

              <label className="archive-manager__form-label">
                Archive Type:
                <select
                  value={archiveType}
                  onChange={(e) => setArchiveType(e.target.value)}
                  className="archive-manager__form-select"
                >
                  <option value="video">Video</option>
                  {/* <option value="audio">Audio</option> */}
                </select>
              </label>

              {archiveType === "video" && (
                <label className="archive-manager__form-label">
                  Upload Video:
                  <input
                    type="file"
                    name="videoFile"
                    onChange={handleFileChange}
                    accept="video/*"
                    required
                    className="archive-manager__form-file-input"
                  />
                </label>
              )}

              {archiveType === "audio" && (
                <>
                  <label className="archive-manager__form-label">
                    Upload Image:
                    <input
                      type="file"
                      name="imageFile"
                      onChange={handleFileChange}
                      accept="image/*"
                      className="archive-manager__form-file-input"
                    />
                  </label>
                  <label className="archive-manager__form-label">
                    Upload Audio:
                    <input
                      type="file"
                      name="audioFile"
                      onChange={handleFileChange}
                      accept="audio/*"
                      required
                      className="archive-manager__form-file-input"
                    />
                  </label>
                </>
              )}

              <div className="archive-manager__dialog-actions">
                <button
                  type="submit"
                  className="archive-manager__submit-btn"
                >
                  Submit
                </button>
                <button
                  type="button"
                  className="archive-manager__cancel-btn"
                  onClick={() => setShowDialog(false)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* <div className="archive-manager__list">
        {archives.map((archive, index) => (
          <div key={index} className="archive-manager__list-item">
            <h3 className="archive-manager__list-item-title">
              {archive.title}
            </h3>
            <p className="archive-manager__list-item-description">
              {archive.description}
            </p>
          </div>
        ))}
      </div> */}
      <div className="archives-container">
      <div className="tabs">
      <button
          className={activeTab === "video" ? "tab active" : "tab"}
          onClick={() => handleTabClick("video")}
        >
          Video
        </button>
        {/* <button
          className={activeTab === "audio" ? "tab active" : "tab"}
          onClick={() => handleTabClick("audio")}
        >
          Audio
        </button> */}
       
      </div>


      <div className="content">
        {activeTab === "audio" &&
          data.imageAudioArchives.map((item) => (
            <div key={item._id} className="card">
              {item.urls && item.urls.length > 0 && (
                <>
                  <img
                    src={`https://riymay.com/assets/${item.urls[0].imageUrl}`}
                    alt={item.title}
                    className="card-image"
                  />
                  <div className="card-content">
                    <h3 className="card-title">{item.title}</h3>




                    <p className="card-description">{item.description}</p>
                    <audio
                      controls
                      src={`https://riymay.com/assets/${item.urls[0].audioUrl}`}
                      className="card-audio"
                    ></audio>

                    <button
                      className="delete-button"
                      onClick={() => handleDelete("audio", item._id)}
                    >
                      Delete
                    </button>
                  </div>
                </>
              )}
            </div>
          ))}

        {activeTab === "video" &&
          data.videoArchives.map((video) => (
            <div key={video._id} className="card">
              <video
                controls
                src={`https://riymay.com/assets/${video.url}`}
                className="card-video"
              ></video>
              <button
                  className="delete-button"
                  onClick={() => handleDelete("video", video._id)}
                >
                  Delete
                </button>
              <div className="card-content">
                <h3 className="card-title">{video.title}</h3>
                
                <p className="card-description">
  {video.description && (
    <>
      {showMore ? video.description : video.description.slice(0, 100)}
      {video.description.length > 100 && (
        <span className="show-more-btn" onClick={() => setShowMore(!showMore)}>
          {showMore ? " Show Less" : " ...Show More"}
        </span>
      )}
    </>
  )}
</p>;
              </div>
            </div>
          ))}
      </div>
    </div>
    </div>
  );
};

export default Archive;
